module.exports = __webpack_public_path__ + "1620db56ecce4f626fbf0f4a70b98cb1.mp4";